import { NgbModalOptions } from "@ng-bootstrap/ng-bootstrap"

// var tenantTypeId = localStorage['tenantTypeId'];
// var isPackagesEnabled = JSON.parse(localStorage['isPackagesEnabled'] ?? null);

export enum RoleType {
  Admin = 1,
  Contact = 2,
  Accountowner = 3,
  GuestUser = 99
}

export enum TenantType {
  MGA = 1,
  Carrier = 2,
  Agency = 3,
  Individual = 4
}

export enum NPNType {
  Firm = 1,
  Individual = 2,
  ExternalCarrier = 3,
  ExternalAgency = 4,
  NonProducerAdmin = 5,
  Onboarding = 6,
  BranchOnboarding = 9
}

export enum AdminDashboardStoreProcedure {
  GetDashboardAppointmentSummary = 1,
  GetDashboardExpiringLicenseSummary = 2,
  GetDashboardLicenseSummary = 3,
  GetDashboardNIPRActivityCount = 4,
  GetDashboardScoreCard = 5,
  GetDashboardStateWiseActiveLicenseData = 6,
  GetDashboardUserSummary = 7,
  GetDashboardLicenseAppointmentGrowth = 8
}

export enum ContactDashboardStoreProcedure {
  GetContactDashboardActiveAppointmentList = 1,
  GetContactDashboardActiveLicenseList = 2,
  GetContactDashboardAppointmentSummary = 3,
  GetContactDashboardNIPRActivity = 4,
  GetContactDashboardLicenseData = 5,
  GetContactDashboardScoreCard = 6,
  GetContactDashboardBranchList = 7,
  GetContactPersonalInformationSummary = 8,
  GetContactLicenseAppointmentGrowth = 9,

}

export enum FirmDashboardStoreProcedure {
  GetFirmBranchInformationSummary = 1,
}

export enum SystemModule {
  Dashboard = 1,
  ContactDashboard = 2,
  Requests = 3,
  Contacts = 4,
  Licenses = 5,
  Appointments = 6,
  LineofAuthorities = 7,
  Setting = 8,
  DashboardContactScorecard = 9,
  DashboardContactDetailScorecard = 10,
  Reports = 11,
  TasksModule = 12,
  NotesModule = 13,
  Help = 14,
  Branch = 15,
  Carrier = 16,
  RegulatoryAction = 17,
  AccountTransaction = 18,
  Downlining = 19,
  OnBoarding = 20,
  Packages = 21,
  EandO = 22,
  Individual = 23,
  ResourcesLibraryModule = 24
}

export enum UserActionType {
  Manually = 1,
  Bulk = 2,
  WithNPN = 3
}

export const DefultCreateYourOwn='create your own';
export const ShepheredTourConst = {
  EandOAdmin: 'EandOAdmin',
  OnboardingAdmin: 'OnboardingAdmin',
  OnboardingUser: 'OnboardingUser',
  AgencyOnboardingUser: 'AgencyOnboardingUser'
}

export const getModulePermission = () => [
  {
    moduleId: SystemModule.Dashboard,
    allowedRole: [RoleType.Accountowner, RoleType.Admin]
  },
  {
    moduleId: SystemModule.ResourcesLibraryModule,
    allowedRole: localStorage['tenantTypeId'] == TenantType.Individual ? [] : [RoleType.Accountowner, RoleType.Admin, RoleType.Contact]
  },
  {
    moduleId: SystemModule.NotesModule,
    allowedRole: localStorage['tenantTypeId'] == TenantType.Individual ? [] : [RoleType.Accountowner, RoleType.Admin, RoleType.Contact]
  },
  {
    moduleId: SystemModule.ContactDashboard,
    allowedRole: [RoleType.Accountowner, RoleType.Admin, RoleType.Contact]
  },
  {
    moduleId: SystemModule.Requests,
    allowedRole: [RoleType.Accountowner, RoleType.Admin]
  },
  {
    moduleId: SystemModule.Contacts,
    allowedRole: [RoleType.Accountowner, RoleType.Admin]
  },
  {
    moduleId: SystemModule.DashboardContactScorecard,
    allowedRole: [RoleType.Accountowner, RoleType.Admin, RoleType.Contact]
  },
  {
    moduleId: SystemModule.Appointments,
    allowedRole: [RoleType.Accountowner, RoleType.Admin, RoleType.Contact]
  },
  {
    moduleId: SystemModule.LineofAuthorities,
    allowedRole: [RoleType.Accountowner, RoleType.Admin]
  },
  {
    moduleId: SystemModule.Setting,
    allowedRole: [RoleType.Accountowner, RoleType.Admin, RoleType.Contact]
  },
  {
    moduleId: SystemModule.DashboardContactScorecard,
    allowedRole: localStorage['tenantTypeId'] == TenantType.Individual ? [] : [RoleType.Accountowner, RoleType.Admin, RoleType.Contact]
  },
  {
    moduleId: SystemModule.DashboardContactDetailScorecard,
    allowedRole: localStorage['tenantTypeId'] == TenantType.Individual ? [] : [RoleType.Accountowner, RoleType.Admin, RoleType.Contact]
  },
  {
    moduleId: SystemModule.Branch,
    allowedRole: [RoleType.Accountowner, RoleType.Admin]
  },
  {
    moduleId: SystemModule.Carrier,
    allowedRole: [RoleType.Accountowner, RoleType.Admin, RoleType.Contact]
  },
  {
    moduleId: SystemModule.RegulatoryAction,
    allowedRole: localStorage['tenantTypeId'] == TenantType.Individual ? [RoleType.Admin, RoleType.Contact, RoleType.Accountowner] : [RoleType.Accountowner, RoleType.Admin]
  },
  {
    moduleId: SystemModule.AccountTransaction,
    allowedRole: [RoleType.Accountowner, RoleType.Admin]
  },
  {
    moduleId: SystemModule.Downlining,
    allowedRole: [RoleType.Accountowner, RoleType.Admin]
  },
  {
    moduleId: SystemModule.Reports,
    allowedRole: [RoleType.Accountowner, RoleType.Admin, RoleType.Contact]
  },
  {
    moduleId: SystemModule.OnBoarding,
    allowedRole: localStorage['tenantTypeId'] == TenantType.Individual ? [] : [RoleType.Admin, RoleType.Contact, RoleType.Accountowner]
  },
  {
    moduleId: SystemModule.EandO,
    allowedRole: localStorage['tenantTypeId'] == TenantType.Individual ? [] : [RoleType.Admin, RoleType.Contact, RoleType.Accountowner]
  },
  {
    moduleId: SystemModule.TasksModule,
    allowedRole: localStorage['tenantTypeId'] == TenantType.Individual ? [] : [RoleType.Admin, RoleType.Contact, RoleType.Accountowner]
  },
  {
    moduleId: SystemModule.Individual,
    allowedRole: localStorage['tenantTypeId'] == TenantType.Individual ? [RoleType.Admin, RoleType.Contact, RoleType.Accountowner, TenantType.Individual] : []
  },
  {
    moduleId: SystemModule.Packages,
    allowedRole: localStorage.getItem('isPackagesEnabled') == 'true' ? [RoleType.Admin, RoleType.Accountowner, RoleType.GuestUser] : []
  }
]

export const manageCarrier = {
  manage: 'manage',
  carrierList: 'manage-carrier-list',
  addCarrier: 'add-carrier',
  editCarrier: 'edit-carrier',
  appointerList: 'appointer-list',
  addAppointer: 'add-appointer',
  editAppointer: 'edit-appointer',

}
export const tenantType = {
  1: 'agent',
  2: 'agent',
  3: 'producer',
  4: 'solo producer'
}
export const tenantTypeCap = {
  1: 'Agent',
  2: 'Agent',
  3: 'Producer',
  4: 'Solo Producer'
}
export const TenantTypeName = {
  1: 'MGA',
  2: 'Carrier',
  3: 'Agency',
  4: 'Solo Producer'
}

export const tenantTypeFirm = {
  1: 'Agencies',
  2: 'Agencies',
  3: 'Branches'
}

export const tenantTypeFirmSingular = {
  1: 'Agency',
  2: 'Agency',
  3: 'Branch'
}

export const TransactionType = {
  1: 'R',
  2: 'NR',
  3: 'NH'
}

export const storageAccount = {
  dropBox: 1
  //, googleDrive: 2, oneDrive: 3, azure: 4
};

export enum LicenseRenewalTransactionType {
  LicenseRenewal = 2
}

export enum ActivityLogType {
  Action = 0,
  Comment = 1,
  NIPRNotification = 2
};

export const ngbModalOptionsSM: NgbModalOptions = {
  backdrop: 'static',
  keyboard: false,
  size: "sm",
  centered: true
};
export const ngbModalOptions: NgbModalOptions = {
  backdrop: 'static',
  keyboard: false,
  centered: true
};
export const ngbModalOptionsClass: NgbModalOptions = {
  backdrop: 'static',
  keyboard: false,
  windowClass: 'right-side-panel',
  centered: true
};
export const ngbModalOptionsLG: NgbModalOptions = {
  backdrop: 'static',
  keyboard: false,
  size: "lg",
  centered: true
};
export const ngbModalOptionsXLClass: NgbModalOptions = {
  backdrop: 'static',
  keyboard: false,
  size: "xl",
  windowClass: 'top-modal'
};
export const ngbModalOptionsMXL: NgbModalOptions = {
  backdrop: 'static',
  keyboard: false,
  size: "mxl",
  centered: true
};
export const ngbModalOptionsXL: NgbModalOptions = {
  backdrop: 'static',
  keyboard: false,
  size: "xl",
  centered: true
};

export const ngbModalOptionsXXL: NgbModalOptions = {
  backdrop: 'static',
  keyboard: false,
  size: "xl",
  centered: true,
  windowClass: 'modal-xxl',
};

export const ngbModalOptionsCenter: NgbModalOptions = {
  backdrop: 'static',
  keyboard: false,
  centered: true
};

export enum FileCategory {
  License = 1,
  Appointment = 2,
  Notes = 3,
  CE = 4,
  Carrier = 5,
  Branches = 6,
  ResourceLibrary = 7,
  Producer = 8,
  RegulatoryAction = 9 ,
  EFT=11,
  WritingCode = 12,

}

export enum BatchType {
  LicenseRenewal = 1,
  NewAppointmnt = 2,
  NewLicense = 3,
  AppointmentTermination = 4,
}

export enum TagType {
  Producer = 1,
  License = 2,
  Appointment = 3,
  Carrier = 4,
  Branch = 5,
  Other = 6,
  FINRA = 7,
}

export const TaskStatus = new Map<number, string>([
  [1, 'New'],
  // [2, 'In Progress'],
  [3, 'Resolved']
]);

export const TaskPriority = new Map<number, string>([
  [3, 'High'],
  [2, 'Medium'],
  [1, 'Low']

]);


export enum TaskType {
  Producer = 1,
  License = 2,
  Appointment = 3,
  Carrier = 4,
  Branch = 5,
  Other = 6,
  Finra = 7,
  EandO = 8,
  Bond = 9,
  RegulatoryAction = 10,
  Onboarding = 11,
  BranchOnboarding = 12,
  Contracting = 13,
}

export enum ReminderType {
  Producer = 1,
  Appointment = 2,
  License = 3,
  Branch = 4,
  EandO = 5,
  Bond = 6,
  RegulatoryAction = 7
}

export enum eandOType {
  eAndO = 1,
  bond = 2
}

export enum RolePermissionType {
  BillingInformationDetails = 1,
  LicenseRenewal = 2,
  NewLicenseApplication = 3,
  NewAppointment = 4,
  AppointmentTermination = 5,
  ProfileInformation = 6,
  ContactNewLicenseApplication = 7,
  SSN = 8,
  DOB = 9,
  Downlining = 10,
  ContactLicenseRenewal = 11
};

export const ImagesBase64 = {
  agenzee: "data:image/png;base64,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",
  
  line: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAIAAAACCAIAAAD91JpzAAAAAXNSR0IArs4c6QAAAA5JREFUGBljeAAGDBAKAEmOCoF9aymLAAAAAElFTkSuQmCC",

  bgLine:"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAQSURBVHgBAQUA+v8A/////wn7A/2j0UkKAAAAAElFTkSuQmCC"
}

export enum DownlineStatus {
  WaitingForAgreement = 1,
  RequestSenttoUpline = 2,
  Accepted = 3,
  Declined = 4,
  DisconnectedbyUpline = 5,
  DisconnectedbyDownline = 6,
  Archived = 7,
  Canceled = 8
};


export enum OnboardingUserStatus {
    Draft = 1,
    Invited = 2,
    InProgress = 3,
    ReadyForReview = 4,
    RequestedAdditionalDocumentation = 5
};

export enum PermissionAccessType {
  No = 0,
  Yes = 1,
  ViewOnly = 2,
  ViewandEdit = 3
};

export enum EstimatedCostError {
  Error = 'Unable to get Estimated Cost.'
};

export enum Constatnt {
  No = 'N',
  Yes = 'Y'
};

export enum ColumnDisplay {
  Text = 0,
  Click = 1,
  Button = 2,
  Tag = 3,
  Checkbox = 4,
  Status = 5,
  Icon = 6,
  Tooltip = 7,
  Date = 8,
  DateTime = 9,
  Link = 10,
  Editable = 11,
  Condition = 12,
  NestedConditon = 13,
  ExpDayDate = 14,
  Address = 15,
  Currency = 16,
  InnerHTML = 17,
}

export enum Tables {
  Dashboard = 1, // not in use
  Dashboard2 = 2, // not in use
  ContactDashboardRegulatory = 3,
  ContactDashboardEandO = 4,
  RequestAppointments = 5,
  RequestLicenses = 6,
  Contacts = 7,
  ArchivedContacts = 8,
  InHibernatedContacts = 9,
  Branches = 10,
  ArchivedBranches = 11,
  Licenses = 12,
  MyLicensesRequest = 13,
  Appointments = 14,
  MyAppointmentsRequest = 15,
  Onboarding = 16,
  OnboardingConfiguration = 17,
  OnboardingRegulatoryActions = 18,
  OnboardingDashboardDocuments = 19,
  OnboardingDashboard2 = 20,
  Carriers = 21,
  EandO = 22,
  ArchivedEandO = 23,
  Task = 24,
  AccountTransactionReport = 25,
  RegulatoryActions = 26,
  DownliningCompanyList = 27,
  DownliningAppointmentList = 28,
  DownliningLicenseList = 29,
  DownliningProducerList = 30,
  CECreadits = 31,
  CEAttachments = 32
}


export enum AgenzeeConvenienceFee {
  NewLicenseForSoloProducer = 1,
  LicenseRenewalForSoloProducer = 2,
  License = 3,
  Appointment = 4,
};

export enum Products {
  SmallBusinessPlan = 1,
  PremiumBusinessPlan = 2,
  EnterpriseBusinessPlan = 3,
  PlatformFee = 4,
  NPNMonitoringFee= 5,
  AgenzeeAssist= 6
};

export const SystemSetting = {
  HideBannerNotificationDuration: 'HideBannerNotificationDuration',
}

export enum CustomFieldType {
  Text = 1,
  Number = 2,
  Date = 3,
  Dropdown = 4
};

export enum PackageRequestStatus {
  New = 1,
  InProgress = 2,
  Completed = 3,
  Appointed = 4,
  Terminated = 5,
  Denied = 6,
  Skipped = 7,
  Review = 8,
  Reviewed = 9,
  Failed = 10
};


